export const SUIVI_FACTURES_EN_RETARD = {
    SET_SCROLL: 'SET_SUIVI_FACTURES_EN_RETARD_SCROLL_POSITION',
    SET_ITEMS_EN_RETARD: 'SET_SUIVI_FACTURES_EN_RETARD_ITEMS',
    ADD_ITEMS: 'ADD_SUIVI_FACTURES_EN_RETARD_ITEMS',
    RESET_ITEMS: 'RESET_SUIVI_FACTURES_EN_RETARD_ITEMS',

    SET_PAGE_EN_RETARD: 'SET_SUIVI_FACTURES_EN_RETARD_PAGE',
    SET_NB_OF_PAGES_EN_RETARD: 'SET_SUIVI_FACTURES_EN_RETARD_NB_OF_PAGES',
    SET_SCROLL_EN_RETARD: 'SET_SUIVI_FACTURES_EN_RETARD_SCROLL',
    SET_COUNT_EN_RETARD: 'SET_SUIVI_FACTURES_EN_RETARD_COUNT',

    SET_SORT_EN_RETARD: 'SET_DEMANDE_FACTURES_EN_RETARD_SORT',

    SET_IS_LOADING_EN_RETARD: 'SET_SUIVI_FACTURES_EN_RETARD_IS_LOADING',
    SET_ERROR_EN_RETARD: 'SET_SUIVI_FACTURES_EN_RETARD_ERROR',
    SET_SUCCESS_EN_RETARD: 'SET_SUIVI_FACTURES_EN_RETARD_SUCCESS',

};
